<template>
  <div class="zoom-container" 
       @mouseenter="showMask = true" 
       @mouseleave="showMask = false"
       @mousemove="handleMouseMove">
    <!-- 原图 -->
    <img ref="originalImg" :src="src" alt="商品图片" class="original-img" />
    
    <!-- 遮罩层 -->
    <div v-show="showMask" 
         class="mask" 
         :style="{ left: maskX + 'px', top: maskY + 'px' }">
    </div>

    <!-- 放大镜 -->
    <div v-show="showMask" 
         class="lens" 
         :style="{ left: lensX + 'px', top: lensY + 'px' }">
      <img :src="src" 
           alt="放大预览" 
           class="zoomed-img"
           :style="{ transform: `scale(${zoomFactor})`, left: imgLeft + 'px', top: imgTop + 'px' }" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'imgZoom',
  props: {
    src: {
      type: String,
      required: true
    },
    maskSize: {
      type: Number,
      default: 100 // 遮罩层大小
    },
    zoomFactor: {
      type: Number,
      default: 2 // 放大倍数
    }
  },
  data() {
    return {
      showMask: false,
      maskX: 0,
      maskY: 0,
      lensX: 0,
      lensY: 0,
      imgLeft: 0,
      imgTop: 0,
      containerWidth: 0,
      containerHeight: 0,
      imgWidth: 0,
      imgHeight: 0
    }
  },
  mounted() {
    this.containerWidth = this.$el.offsetWidth
    this.containerHeight = this.$el.offsetHeight
    this.imgWidth = this.$refs.originalImg.naturalWidth
    this.imgHeight = this.$refs.originalImg.naturalHeight

    // 监听图片加载完成
    this.$refs.originalImg.onload = () => {
      this.imgWidth = this.$refs.originalImg.naturalWidth
      this.imgHeight = this.$refs.originalImg.naturalHeight
    }
  },
  methods: {
    handleMouseMove(e) {
      const rect = this.$el.getBoundingClientRect()
      const x = e.clientX - rect.left
      const y = e.clientY - rect.top

      // 计算遮罩位置（限制在图片范围内）
      let maskX = x - this.maskSize / 2
      let maskY = y - this.maskSize / 2

      // 限制遮罩不超出图片边界
      maskX = Math.max(0, Math.min(this.containerWidth - this.maskSize, maskX))
      maskY = Math.max(0, Math.min(this.containerHeight - this.maskSize, maskY))

      this.maskX = maskX
      this.maskY = maskY

      // 计算放大镜位置（偏移遮罩大小的一半，避免遮挡）
      this.lensX = x + this.maskSize / 2
      this.lensY = y + this.maskSize / 2

      // 计算放大图片的位置
      this.imgLeft = -maskX * this.zoomFactor
      this.imgTop = -maskY * this.zoomFactor
    }
  }
}
</script>

<style scoped>
.zoom-container {
  position: relative;
  display: inline-block;
  overflow: hidden;
  cursor: crosshair;
}

.original-img {
  width: 100%;
  height: auto;
  display: block;
}

.mask {
  position: absolute;
  width: 100px;
  height: 100px;
  background: rgba(0, 0, 0, 0.3);
  pointer-events: none;
  z-index: 2;
}

.lens {
  position: absolute;
  width: 200px;
  height: 200px;
  top: 0;
  left: 0;
  border: 2px solid #ddd;
  overflow: hidden;
  z-index: 3;
  pointer-events: none;
}

.zoomed-img {
  position: absolute;
  width: 100%;
  height: auto;
  top: 0;
  left: 0;
}
</style>